
import { Component, Vue, Watch } from 'vue-property-decorator';

import user_service from '@/modules/user';

import Toast from 'primevue/toast';

Vue.component('Toast', Toast);

// @ts-ignore
import Loading from 'vue-loading-overlay';

Vue.component('Loading', Loading);
import 'vue-loading-overlay/dist/vue-loading.css';
import user_module from '@/modules/user';

@Component
export default class App extends Vue {
  guest = false;
  displayCallWindow = true;

  get user() {
    console.log('@@@@@ getter for user: ', user_module.userInfo);
    return user_module.userInfo;
  }

  get isLoading() {
    return this.$store.getters.isLoader || false;
  }

  
  @Watch('$route')
  postMessage(){

    if (this.APPSTORE){

      const path: string = this.$route.fullPath;
      window.parent.postMessage({href: path, product: 'pdf'}, '*');

    }

  }

  get APPSTORE(){

    return user_module.APPSTORE;

  }

  receiveMessage(message: any){

    const {data} = message;

    if (data.href){
        
      const newMessage = data.href.replace(/fundscreener\//, '');

      console.log('route!!!', message?.data?.href, this.$route.fullPath)

      if ('/' + message?.data?.href !== this.$route.fullPath){

        this.$router.push({ path: newMessage})

      }
      
    }

  }
  
  created(): void {

    // @ts-ingore
    // console.log("@@@@@ PDFObject: ", PDFObject)

    const urlParams = new URLSearchParams(window.location.search);

    const APPSTORE = urlParams.has("appstore");

    user_module.setAPPSTORE(APPSTORE)

    console.log('APPSTORE?', APPSTORE);

    if (APPSTORE){

      window.addEventListener('message', this.receiveMessage);

    }

    this.$route.params.id = "index";

  }
}
